import React, { useState, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import { MessageBanner, Modal, ModalFooter, Button, RadioButton, RadioButtonGroup, TextArea, } from "@folio/stripes/components";
import { EXTRA_COPY_REASONS } from "../../types/enforcement";
export var AddExtraCopyDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, label = _a.label, confirmLabel = _a.confirmLabel, errorMessage = _a.errorMessage;
    var formatMessage = useIntl().formatMessage;
    var _c = useState(""), reason = _c[0], setReason = _c[1];
    var _d = useState(""), note = _d[0], setNote = _d[1];
    useEffect(function () {
        if (!open) {
            setReason("");
            setNote("");
        }
    }, [open]);
    var isOtherReason = reason === "OTHER";
    var isValid = reason !== "" && (!isOtherReason || note.trim().length > 0);
    var handleSubmit = useCallback(function () {
        if (reason) {
            onSubmit(reason, note.trim());
        }
    }, [reason, note, onSubmit]);
    return (React.createElement(Modal, { open: open, label: label !== null && label !== void 0 ? label : formatMessage({
            id: "ui-br-legaldeposits.enforcement.extraCopy.title",
        }), onClose: onClose, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !isValid || isLoading }, confirmLabel !== null && confirmLabel !== void 0 ? confirmLabel : formatMessage({ id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: onClose }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement(RadioButtonGroup, { label: formatMessage({
                id: "ui-br-legaldeposits.enforcement.extraCopy.reasonLabel",
            }), value: reason, onChange: function (e) {
                return setReason(e.target.value);
            } }, EXTRA_COPY_REASONS.map(function (opt) { return (React.createElement(RadioButton, { key: opt.value, label: formatMessage({ id: opt.labelId }), value: opt.value })); })),
        React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-legaldeposits.enforcement.extraCopy.noteLabel",
            }), value: note, onChange: function (e) {
                return setNote(e.target.value);
            }, required: isOtherReason }),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage))));
};
